import { GridContainer } from "@amzn/stencil-react-components/layout";
import { Col } from "@amzn/stencil-react-components/layout";
import { PaginationVariant } from "@amzn/stencil-react-components/pagination";
import { Text } from "@amzn/stencil-react-components/text";
import { Pagination } from "@amzn/uxm-stencil-react-components/lib/src/stencil";
import { AiForMeItem } from "common/components/AIForMe/AiForMeItem";
import { useCompare } from "common/context/compare";
import { TrackClickInteraction } from "common/helpers";
import { VoteHandler } from "common/hooks";
import { getString } from "common/uistringlabels/uiStringUtils";
import { AIForMeTool } from "lib/models/aiforme-models";
import { CatalogicalService } from "lib/services";
import React, { FC, useState } from "react";

const TOOLS_PER_PAGE = 3;
const FIRST_PAGE = 1;

export interface TrendingToolsSectionProps {
  tools: AIForMeTool[];
  voteHandler: VoteHandler;
  client: CatalogicalService<AIForMeTool>;
  /** Callback to track click interactions when user clicks "Learn More" */
  onTrackClick: TrackClickInteraction;
}

export const TrendingToolsSection: FC<TrendingToolsSectionProps> = ({ tools, voteHandler, client, onTrackClick }) => {
  const [currentPage, setCurrentPage] = useState(FIRST_PAGE);
  const { addTool, removeTool, selectedToolIds, canAddMore } = useCompare();

  if (tools.length === 0) {
    return null;
  }

  const totalPages = Math.ceil(tools.length / TOOLS_PER_PAGE);
  const startIndex = (currentPage - 1) * TOOLS_PER_PAGE;
  const displayedTools = tools.slice(startIndex, startIndex + TOOLS_PER_PAGE);

  return (
    <Col rowGap={24} alignItems="center" data-testid="trending-tools-section">
      <Text fontSize="T400" fontWeight="bold" data-testid="trending-tools-heading">
        {getString("aiForMe.landingPage.weeklyTrendingToolsSection.sectionTitle")}
      </Text>

      <GridContainer>
        {displayedTools.map((tool, index) => {
          const isCompareSelected = selectedToolIds.has(tool.taxonomyId);
          return (
            <AiForMeItem
              key={tool.taxonomyId}
              item={tool}
              index={startIndex + index}
              voteHandler={voteHandler}
              client={client}
              gridSpan={{ lg: 4, md: 4 }}
              isCompareSelected={isCompareSelected}
              isCompareDisabled={!canAddMore && !isCompareSelected}
              onCompareAdd={addTool}
              onCompareRemove={removeTool}
              onTrackClick={onTrackClick}
              removeQuickRate={true}
            />
          );
        })}
      </GridContainer>

      {totalPages > 1 && (
        <Pagination
          numberOfPages={totalPages}
          selectedPage={currentPage}
          onPageSelect={setCurrentPage}
          variant={PaginationVariant.Dotted}
          touchpoint="trending-tools-pagination"
        />
      )}
    </Col>
  );
};
